module.exports = __webpack_public_path__ + "resources/img/img_ssl_ceritificate1_m.b3b9cbeb1c444b7f337cd19ca7194ddc.png";